"use strict";

exports.__esModule = true;
exports.modernizeDocumentColor = modernizeDocumentColor;
exports.modernizeThresholds = modernizeThresholds;
exports.modernizeValueTuples = modernizeValueTuples;
var _base = _interopRequireDefault(require("../../../Themes/base"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// Dashboards and reports store colours of their own: metric thresholds,
// raw-value rules, custom colours, and whatever was picked from the colour
// picker. Many of them are the legacy plant-state pastels, chosen because they
// meant "producing" or "down". Under the modern UI those spellings are read
// as the state they stood for and drawn with the modern token, so a table
// coloured by utilization thresholds follows the restyle. Any other colour is
// left exactly as the document says.
var STATE_TOKENS = ["ProducingStateColor", "SetupStateColor", "StandbyStateColor", "UnplannedDowntimeStateColor", "PlannedDowntimeStateColor", "DataUnavailableStateColor", "ShutdownStateColor"];
var hex2 = function hex2(n) {
  return Math.max(0, Math.min(255, Number(n))).toString(16).padStart(2, "0");
};

// "#6FC376", "#6fc376", "rgb(111, 195, 118)" all become "#6fc376".
function canonical(color) {
  if (typeof color !== "string") {
    return undefined;
  }
  var text = color.trim().toLowerCase();
  var rgb = text.match(/^rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/);
  if (rgb) {
    return "#" + hex2(rgb[1]) + hex2(rgb[2]) + hex2(rgb[3]);
  }
  var _short = text.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/);
  if (_short) {
    return "#" + _short[1] + _short[1] + _short[2] + _short[2] + _short[3] + _short[3];
  }
  return /^#[0-9a-f]{6}$/.test(text) ? text : undefined;
}
var LEGACY_TOKEN_BY_COLOR = STATE_TOKENS.reduce(function (map, token) {
  map[canonical(_base["default"][token])] = token;
  return map;
}, {});

/**
 * The colour to draw for one a document stores: the modern state colour when
 * the document spelt a legacy state pastel and the theme is the modern one,
 * otherwise the colour itself.
 */
function modernizeDocumentColor(theme, color) {
  if (!theme || !theme.uiModern) {
    return color;
  }
  var token = LEGACY_TOKEN_BY_COLOR[canonical(color)];
  return token && theme[token] ? theme[token] : color;
}

/**
 * Metric thresholds (`[[value, colour], ...]`) with their colours mapped.
 * Returns the same array when nothing changes.
 */
function modernizeThresholds(theme, thresholds) {
  if (!theme || !theme.uiModern || !Array.isArray(thresholds)) {
    return thresholds;
  }
  var changed = false;
  var mapped = thresholds.map(function (threshold) {
    if (!Array.isArray(threshold)) {
      return threshold;
    }
    var color = modernizeDocumentColor(theme, threshold[1]);
    if (color === threshold[1]) {
      return threshold;
    }
    changed = true;
    return [threshold[0], color];
  });
  return changed ? mapped : thresholds;
}

/**
 * Raw-value rules (`[{ value, color, eqType }, ...]`) with their colours
 * mapped. Returns the same array when nothing changes.
 */
function modernizeValueTuples(theme, tuples) {
  if (!theme || !theme.uiModern || !Array.isArray(tuples)) {
    return tuples;
  }
  var changed = false;
  var mapped = tuples.map(function (tuple) {
    var color = tuple ? modernizeDocumentColor(theme, tuple.color) : undefined;
    if (!tuple || color === tuple.color) {
      return tuple;
    }
    changed = true;
    return Object.assign({}, tuple, {
      color: color
    });
  });
  return changed ? mapped : tuples;
}